import { useDeviceType } from "@hook/useDeviceType";
import { useGetCancelBroadbandEligibility } from "@modules/eirCustomersFacade/swr";
import { useCallback, useState } from "react";
import { TCancelOrder } from "../type/TCancelOrder";
import { useFetchState } from "@hook/useFetchState";

interface IParams {
    cancelOrder?: TCancelOrder;
    isEligibleToCancel: boolean;
    orderReference: string;
}

export const useOrderOffer = (props: IParams) => {
    const { cancelOrder, isEligibleToCancel, orderReference } = props;
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const { isMobile } = useDeviceType();
    const { data: cancelBroadbandEligibilityResponse } = useGetCancelBroadbandEligibility(
        isEligibleToCancel,
        orderReference
    );
    const { startFetching, endFetching, isLoading } = useFetchState();

    const cancelBroadbandOrder = useCallback(async () => {
        if (cancelOrder) {
            try {
                startFetching();
                await cancelOrder(orderReference);
                setIsCancelModalOpen(false);
                endFetching();
            } catch (error) {
                // TODO GAW-304
                endFetching(error);
            }
        }
    }, [cancelOrder, endFetching, orderReference, startFetching]);

    return {
        cancelBroadbandOrder,
        displayCancelButton: cancelBroadbandEligibilityResponse?.displayCancelButton,
        isCancelModalOpen,
        isLoading,
        isMobile,
        setIsCancelModalOpen,
    };
};
